/** Mirrors backend VOICE_MAX_SECONDS (backend/core/voice/settings.py). Keep the two equal by hand. */
export const VOICE_MAX_SECONDS = 3600;
/** Speech-grade bitrate: an hour of Opus is about 14 MB (TD-091). */
export const VOICE_BITS_PER_SECOND = 32_000;
export const VOICE_POLL_MS = 3000;
